import { render, staticRenderFns } from "./TsAudienceCards.vue?vue&type=template&id=09368ddb&scoped=true"
import script from "./TsAudienceCards.vue?vue&type=script&lang=ts"
export * from "./TsAudienceCards.vue?vue&type=script&lang=ts"
import style0 from "./TsAudienceCards.vue?vue&type=style&index=0&id=09368ddb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09368ddb",
  null
  
)

export default component.exports